import { DialogHeader, pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Wrapper = styled.div `
  width: 100%;
  overflow: auto;
  max-height: ${pxToRem(800)};
  transition: max-height 0.2s ease-in-out;
`;
export const StyledDialogHeader = styled(DialogHeader) `
  border-bottom: ${pxToRem(1)} solid ${theme.semantic.border.default};
  padding: ${theme.spacing.md} 0;
`;
